import type React from "react";
import { useContext } from "react";

import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Notification } from "shared/atoms/Notification";
import { CurrentPatientContext } from "utils/contexts";

import { InformationRoutes } from "../components/Information";
import { PatientSubMenu } from "../components/PatientSubMenu";

export const Information: React.FC = () => {
  const { t } = useTranslation();
  const { patientError } = useContext(CurrentPatientContext);

  return patientError ? (
    <Stack alignItems="center" justifyContent="center" minHeight="300px">
      <Notification variant="danger" style={{ margin: "10px" }}>
        {t("errors.generic")}
      </Notification>
    </Stack>
  ) : (
    <Stack spacing={3} px={2} pb={5}>
      <PatientSubMenu />
      <InformationRoutes />
    </Stack>
  );
};
